// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ocw7","comment":"styles_comment__1kfx8"};